import React, { useState } from 'react';
import { changePasswordApi } from 'core/features/auth/authApi';

const inputKlasse =
  'w-full rounded-lg border border-line bg-paper px-3 py-2 text-ink focus:border-brand-600 focus:outline-none';

/**
 * Modaler Dialog zum Aendern des Login-Passworts: fragt das aktuelle Passwort
 * ab, prueft die Wiederholung und setzt das neue Passwort ueber die Auth-API.
 * Die Tresor-Passphrase des gesicherten Modus ist davon unabhaengig.
 */
export default function PasswortAendernDialog({ onClose }) {
  const [aktuell, setAktuell] = useState('');
  const [neu, setNeu] = useState('');
  const [wiederholung, setWiederholung] = useState('');
  const [fehler, setFehler] = useState(null);
  const [laeuft, setLaeuft] = useState(false);
  const [erfolg, setErfolg] = useState(false);

  const pruefeEingaben = () => {
    if (neu.length < 6) return 'Das neue Passwort muss mindestens 6 Zeichen lang sein.';
    if (neu !== wiederholung) return 'Die Wiederholung stimmt nicht mit dem neuen Passwort überein.';
    return null;
  };

  const absenden = async (e) => {
    e.preventDefault();
    const eingabeFehler = pruefeEingaben();
    if (eingabeFehler) {
      setFehler(eingabeFehler);
      return;
    }
    setFehler(null);
    setLaeuft(true);
    try {
      await changePasswordApi(aktuell, neu);
      setErfolg(true);
      setTimeout(onClose, 1200);
    } catch (ex) {
      setFehler(ex.response?.data?.error || 'Passwort-Änderung fehlgeschlagen. Bitte erneut versuchen.');
      setLaeuft(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl bg-paper p-6 shadow-xl">
        <h2 className="mb-4 font-serif text-xl font-semibold text-ink">Passwort ändern</h2>

        {erfolg ? (
          <p className="rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
            Passwort erfolgreich geändert.
          </p>
        ) : (
          <form onSubmit={absenden} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-ink">Aktuelles Passwort</label>
              <input
                type="password"
                value={aktuell}
                onChange={(e) => setAktuell(e.target.value)}
                autoComplete="current-password"
                className={inputKlasse}
                autoFocus
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-ink">Neues Passwort</label>
              <input
                type="password"
                value={neu}
                onChange={(e) => setNeu(e.target.value)}
                autoComplete="new-password"
                className={inputKlasse}
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-ink">Neues Passwort wiederholen</label>
              <input
                type="password"
                value={wiederholung}
                onChange={(e) => setWiederholung(e.target.value)}
                autoComplete="new-password"
                className={inputKlasse}
              />
            </div>

            {fehler && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{fehler}</p>}

            <div className="flex justify-end gap-2 pt-1">
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg border border-line px-3 py-2 text-sm font-medium text-ink-muted transition-colors hover:bg-ink/5"
              >
                Abbrechen
              </button>
              <button
                type="submit"
                disabled={laeuft}
                className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-500 disabled:opacity-50"
              >
                {laeuft ? 'Ändere…' : 'Passwort ändern'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
